import axios from "../data/http/axios";

export async function getUserSettings() {
    return (await axios.get('/accountUser/settings')).data
}

export async function setUserSettings(settings) {
    return (await axios.put('/accountUser/settings', settings)).data
}